import React, { useCallback, useRef } from 'react';
import { getAssetPath } from '../utils/paths';

const Footer = ({ onShowComingSoon }) => {
  const isProcessing = useRef(false);
  
  const handleClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (isProcessing.current) {
      return;
    }
    
    if (onShowComingSoon) {
      isProcessing.current = true;
      onShowComingSoon();
      setTimeout(() => {
        isProcessing.current = false;
      }, 500);
    }
  }, [onShowComingSoon]);

  return (
    <footer className="site-footer footer-style-two pos-rel pt-85">
      <div className="container">
        {/* <div className="row">
          <div className="crm-community text-center">
            <ul className="crm-community__social ul_li_center mb-35">
              <li><a href="#!"><img src={getAssetPath('/Helax/assets/img/icon/discord.png')} alt="Discord" /></a></li>
              <li><a href="#!"><img src={getAssetPath('/Helax/assets/img/icon/whatsapp.png')} alt="WhatsApp" /></a></li>
              <li><a href="#!"><img src={getAssetPath('/Helax/assets/img/icon/telegram.png')} alt="Telegram" /></a></li>
            </ul>
            <div className="crm-title text-center mb-40">
              <h2 className="crm-title__heading">Join our Global Community</h2>
            </div>
            <a className="thm-btn thm-btn--gradient style-2" href="#!">Join us Now</a>
          </div>
        </div> */}
        <div className="row mt-none-30 pb-90">
          <div className="col-lg-6 col-md-6 mt-30">
            <div className="footer__cta" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <div>
                <img src="/footer_logo.svg" alt="Footer Logo" style={{ maxHeight: '80px', width: 'auto', display: 'block' }} />
              </div>
              <div style={{ marginTop: 'auto', paddingLeft: '15px' }}>
                <a
                  className="thm-btn thm-btn--gradient style-2 br-5"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSehBzhq1MGjsRHfbNXtG2qia_9GQeV_NS3K5NZ5kamnunb53Q/viewform?usp=dialog"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Early supporter
                </a>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-4 col-md-6 mt-30">
            <div className="footer__cta pl-45">
              <span className="title">QUICK CONTACT</span>
              <h4>If you have questions, please use our 24- <br />hour helpline</h4>
              <span className="cta-number">
                <span><img src={getAssetPath('/Helax/assets/img/icon/np_icon2.svg')} alt="" /></span>760 398-3535
              </span>
            </div>
          </div> */}
          <div className="col-lg-6 col-md-6 mt-30">
            <div className="footer__cta text-lg-end" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <span className="title">FOLLOW US</span>
              <ul className="footer__cta-social ul_li_right mb-60">
                <li><a href="#!" onClick={handleClick}><i className="fas fa-exchange-alt"></i></a></li>
                <li><a href="https://x.com/novaverseio" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a></li>
                <li><a href="#!" onClick={handleClick}><i className="fas fa-file-alt"></i></a></li>
              </ul>
              <ul className="footer__cta-link ul_li_right" style={{ marginTop: 'auto' }}>
                <li><a href="#!" onClick={handleClick}>Docs</a></li>
                <li><a href="#!" onClick={handleClick}>Exchange</a></li>
                <li><a href="https://x.com/novaverseio" target="_blank" rel="noopener noreferrer">X (Twitter) </a></li>
                <li><a href="mailto:support@novaverse.io">support@novaverse.io</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="footer__copyright">
        <div className="container">
          <div className="ul_li_between mt-none-10">
            <div className="footer__copyright-text mt-10">
              © 2023 Helax - Tech startup . All Rights Reserved.
            </div>
            <ul className="footer__social ul_li mt-10">
              <li><a href="#!"><i className="fab fa-facebook"></i></a></li>
              <li><a href="https://x.com/novaverseio" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a></li>
              <li><a href="#!"><i className="fab fa-instagram"></i></a></li>
              <li><a href="#!"><i className="fab fa-pinterest"></i></a></li>
            </ul>
          </div>
        </div>
      </div> */}
      <div className="crm-footer__shape">
        <div className="shape shape--1" data-parallax='{"y" : 70}'>
          <img src={getAssetPath('/Helax/assets/img/shape/fot_shape1.png')} alt="" />
        </div>
        <div className="shape shape--2" data-parallax='{"y" : 80}'>
          <img src={getAssetPath('/Helax/assets/img/shape/fot_shape3.png')} alt="" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;

